import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Container, Grid, Typography, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import PlayCircleOutlineIcon from "@material-ui/icons/PlayCircleOutline";
import Simplify from "../../assets/images/Simplify.png";
import AutomatedTuitionRate from "../../assets/images/AutomatedTuitionRate.png";
import OnlinePayment from "../../assets/images/OnlinePayment.png";
import FinancialDataSorting from "../../assets/images/FinancialDataSorting.png";
import SiplifiedAccounting from "../../assets/images/SiplifiedAccounting.png";
import AutomateTuitionPlan from "../../assets/images/AutomateTuitionPlan.png";
import SendOnlineInvoice from "../../assets/images/online_invoices.svg";
import CollectPayment from "../../assets/images/CollectPayment.png";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    padding: "0px 30px",
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      padding: 0,
    },
  },
  banner: {
    background: "#E3EBFC",
    borderRadius: 10,
    padding: 50,
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      padding: 0,
      marginTop: 10,
    },
  },
  banner_no_background: {
    borderRadius: 10,
    padding: 50,
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      padding: 0,
      marginTop: 10,
    },
  },

  banner_big_border_radious: {
    background: "#E3EBFC",
    borderRadius: 20,
    padding: 50,
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      padding: 0,
      marginTop: 10,
    },
  },

  banner_image: {
    flex: 1,
    padding: 30,
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  banner_content: {
    flex: 1,
    padding: 30,
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      padding: 20,
    },
  },
  banner_button: {
    padding: "13px 35px  !important",
    [theme.breakpoints.down("sm")]: {
      marginBottom: 10,
    },
  },
  banner_headline: {
    fontWeight: 600,
    marginBottom: 80,
    [theme.breakpoints.down("sm")]: {
      marginBottom: 40,
    },
    [theme.breakpoints.down("xs")]: {
      marginBottom: 20,
      fontSize: "1.8rem",
    },
  },
  banner_content_text: {
    fontSize: 24,
    marginBottom: 30,
    [theme.breakpoints.down("xs")]: {
      fontSize: 18,
    },
  },
  activity_wrapper: {
    padding: "60px 120px",
    [theme.breakpoints.down("xs")]: {
      padding: "20px 0px",
    },
  },

  activity_box: {
    textAlign: "center",
  },
  activity_image: {
    maxWidth: "100%",
    padding: "0px 40px 15px 40px",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "45%",
    },
  },
  center_button: {
    textAlign: "center",
    marginTop: 40,
  },
  marginStyle: {
    [theme.breakpoints.down("xs")]: {
      margin: "0 !important",
    },
  },
}));
const Billing = () => {
  const classes = useStyles();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Container maxWidth="lg">
        <Grid container className={classes.wrapper}>
          <Grid item lg={12} md={12}>
            <div className={classes.banner}>
              <div className={classes.banner_content}>
                <Typography variant="h3" className={classes.banner_headline}>
                  Simplify your billing system
                </Typography>
                <Typography className={classes.banner_content_text}>
                  Manage every aspect of your finances in one system.
                </Typography>
                <div>
                  <Link to="/try-it-free">
                    <Button
                      variant="contained"
                      color="primary"
                      className={`${classes.banner_button} button`}
                    >
                      Try it Free
                    </Button>
                  </Link>
                </div>
              </div>
              <div className={classes.banner_image}>
                <img src={Simplify} alt="" />
              </div>
            </div>
          </Grid>
        </Grid>
      </Container>

      <Container maxWidth="lg">
        <Grid container className={classes.wrapper}>
          <Grid item lg={12} md={12}>
            <div className={classes.banner_no_background}>
              <div className={classes.banner_content}>
                <Typography variant="h4" style={{ textAlign: "start" }}>
                  Automate Tuition rate & Billing setup
                </Typography>

                <Typography
                  variant="h6"
                  style={{ textAlign: "start" }}
                  className={classes.marginStyle}
                >
                  Set-up individual billing accounts for each of your clients.
                  Automatically invoice them at the end of each pay period to
                  ensure you receive your payment on time.
                </Typography>
              </div>
              <div className={classes.banner_image}>
                <img src={AutomatedTuitionRate} alt="" />
              </div>
            </div>
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth="lg">
        <Grid container className={classes.wrapper}>
          <Grid item lg={12} md={12}>
            <div className={classes.banner_big_border_radious}>
              <div className={classes.banner_image}>
                <img src={OnlinePayment} alt="" />
              </div>
              <div className={classes.banner_content}>
                <Typography variant="h4" style={{ textAlign: "start" }}>
                  Online Payment Option
                </Typography>

                <Typography
                  variant="h6"
                  style={{ textAlign: "start" }}
                  className={classes.marginStyle}
                >
                  Allow parents to pay for their tuition through their online
                  account. Make it easy for them to link their payment platform
                  with KinderCubby and pay in one click.
                </Typography>
              </div>
            </div>
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth="lg">
        <Grid container className={classes.wrapper}>
          <Grid item lg={12} md={12}>
            <div className={classes.banner_no_background}>
              <div className={classes.banner_content}>
                <Typography variant="h4" style={{ textAlign: "start" }}>
                  Financial Data sorting, Segmentation
                </Typography>

                <Typography
                  variant="h6"
                  style={{ textAlign: "start" }}
                  className={classes.marginStyle}
                >
                  Receive data reports that provide your childcare center with
                  financial insight. Learn about your revenue, operating margin,
                  and profit that drives your business.
                </Typography>
              </div>
              <div className={classes.banner_image}>
                <img src={FinancialDataSorting} alt="" />
              </div>
            </div>
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth="lg">
        <Grid container className={classes.wrapper}>
          <Grid item lg={12} md={12}>
            <div className={classes.banner_big_border_radious}>
              <div className={classes.banner_image}>
                <img src={SiplifiedAccounting} alt="" />
              </div>
              <div className={classes.banner_content}>
                <Typography variant="h4" style={{ textAlign: "start" }}>
                  Simplified accounting reports
                </Typography>

                <Typography
                  variant="h6"
                  style={{ textAlign: "start" }}
                  className={classes.marginStyle}
                >
                  Easily generate and read your balance sheets to learn more
                  about the financial health of your daycare center.
                </Typography>
              </div>
            </div>
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth="lg">
        <Grid
          container
          spacing={3}
          justify="center"
          alignItems="center"
          className={classes.activity_wrapper}
        >
          <Grid item lg={12} md={12}>
            <Typography variant="h4">
              Getting started is as easy as 1-2-3
            </Typography>
          </Grid>

          <Grid item lg={4} md={4} className={classes.activity_box}>
            <img
              className={classes.activity_image}
              src={AutomateTuitionPlan}
              alt=""
            />

            <div className={classes.activity_content}>
              <Typography variant="h5">Automate tuition plan</Typography>
              <Typography variant="subtitle1">
                Set-up automatic, recurring payments to minimize stress for
                parents.
              </Typography>
            </div>
          </Grid>

          <Grid item lg={4} md={4} className={classes.activity_box}>
            <img
              className={classes.activity_image}
              src={SendOnlineInvoice}
              alt=""
            />

            <div className={classes.activity_content}>
              <Typography variant="h5">Send online Invoice</Typography>
              <Typography variant="subtitle1">
                Distribute digital tuition invoices to all parents inside our
                platform.
              </Typography>
            </div>
          </Grid>

          <Grid item lg={4} md={4} className={classes.activity_box}>
            <img
              className={classes.activity_image}
              src={CollectPayment}
              alt=""
            />

            <div className={classes.activity_content}>
              <Typography variant="h5">Collect Payment</Typography>
              <Typography variant="subtitle1">
                Receive digital payments from your clients and deposit into your
                bank account.
              </Typography>
            </div>
          </Grid>
          <Grid item lg={12} md={12}>
            <div className={classes.center_button}>
              <Link to="/try-it-free">
                <Button
                  variant="contained"
                  color="primary"
                  className={`${classes.banner_button} button`}
                >
                  Yes! Let’s try it.
                </Button>
              </Link>
            </div>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default Billing;
